// src/App.js
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import {AppProviders} from "./Providers";
import { useUser } from './contexts/UserProvider';
import HomePage from "./pages/HomePage";
import RequestAttire from "./pages/RequestAttire";
import NotFoundPage from "./pages/NotFoundPage";
import TermsAndConditions from "./pages/TermsAndConditionPage";
import SignUp from "./pages/SignUp";
import Login from "./pages/Login";
import MyBookings from "./pages/MyBookings";
import Profile from "./pages/Profile";
import AllAppointments from './pages/AllAppointments';
import PrivacyPolicy from "./pages/PrivacyPolicyPage";
import RequestDeletion from "./pages/RequestDeletion";

alertify.set('notifier', 'position', 'top-right');
alertify.set('notifier', 'delay', 5);

function App() {

  return (
    <MainApp />
  );
}

function MainApp() {



  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<LandingPage />} /> */}
        <Route path="/" element={<HomePage />} />

        <Route path="/bookings" element={<RequestAttire />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/all-appointments" element={<AllAppointments />} />

        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/sign-up" element={<SignUp />} />

        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/request-deletion" element={<RequestDeletion />} />

        {/* page not found route should be the last route */}
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </Router>
  )
}

export default App;